var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex w-full overflow-hidden -mt-3 h-full" },
    [
      _c(
        "LoadingOverlay",
        {
          staticClass: "w-full",
          attrs: {
            loading: _vm.apolloLoading || _vm.loading,
            hasData: _vm.isDataLoaded,
          },
        },
        [
          _vm.empty
            ? _c(
                "EmptyListPlaceholder",
                {
                  attrs: {
                    title: _vm.noConversationsPlaceholder,
                    subtitle: _vm.emptyListSubtitle,
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "image",
                        fn: function () {
                          return [_c("EmptyListImageInbox")]
                        },
                        proxy: true,
                      },
                    ],
                    null,
                    false,
                    1693747661
                  ),
                },
                [
                  !_vm.isContractor
                    ? _c("NewConversationButtonWithModal", {
                        attrs: {
                          size: "lg",
                          companyId: _vm.company.id,
                          currentUserId: _vm.currentUser.id,
                          currentUserRole: _vm.currentUser.role,
                        },
                        on: {
                          createConversation: _vm.handleCreateConversation,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : _c(
                "div",
                {
                  staticClass:
                    "inbox-window flex w-auto sm:w-full flex-col h-full",
                },
                [
                  _vm.isMobile
                    ? _c("div", { staticClass: "h-full" }, [
                        !_vm.selectedConversationId
                          ? _c("div", { staticClass: "h-full" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-col containerWidth p-3 bg-white h-full",
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "flex flex-wrap justify-between items-center titleHeight sm:mr-4",
                                    },
                                    [
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "text-primary-black text-lg font-semibold mainHead ml-3 pt-4 pb-5 sm:p-4",
                                        },
                                        [_vm._v(" Inbox ")]
                                      ),
                                      !_vm.isContractor
                                        ? _c("NewConversationButtonWithModal", {
                                            staticClass:
                                              "md:m-0 sm:pt-4 sm:pb-4 sm:p-4 sm:pl-6 md:pl-8 mr-3",
                                            attrs: {
                                              size: "lg",
                                              companyId: _vm.company.id,
                                              currentUserId: _vm.currentUser.id,
                                              currentUserRole:
                                                _vm.currentUser.role,
                                            },
                                            on: {
                                              createConversation:
                                                _vm.handleCreateConversation,
                                            },
                                          })
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "CustomScroll",
                                    {
                                      staticClass:
                                        "sm:mr-4 flex-1 scroll-override",
                                    },
                                    [
                                      _c("InboxConversations", {
                                        attrs: {
                                          conversations: _vm.conversations,
                                          currentUserId: _vm.currentUser.id,
                                          selectedConversationId:
                                            _vm.selectedConversationId,
                                        },
                                        on: {
                                          conversationSelected:
                                            _vm.selectConversation,
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ])
                          : _c(
                              "div",
                              [
                                _vm.loadingConversation && !_vm.conversation
                                  ? [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center justify-center h-96",
                                        },
                                        [
                                          _c(
                                            "p",
                                            { staticClass: "text-gray-500" },
                                            [_vm._v("Loading conversation...")]
                                          ),
                                        ]
                                      ),
                                    ]
                                  : _c("InboxWindow", {
                                      staticClass:
                                        "w-full sm:p-3 sm:pb-0 sm:pl-5 p-4 pt-0",
                                      attrs: {
                                        conversation: _vm.conversation,
                                        selectedConversationId:
                                          _vm.selectedConversationId,
                                        currentUserId: _vm.currentUser.id,
                                        predefinedMessage:
                                          _vm.predefinedMessage,
                                        currentUser: _vm.currentUser,
                                        uploadingAttachmentId:
                                          _vm.uploadingAttachmentId,
                                      },
                                      on: {
                                        showAllConversation:
                                          _vm.clearSelectedConversation,
                                        conversationDeleted:
                                          _vm.handleConversationDeleted,
                                        newMessage: _vm.sendMessage,
                                      },
                                    }),
                              ],
                              2
                            ),
                      ])
                    : _c(
                        "div",
                        { staticClass: "flex w-full flex-row h-full" },
                        [
                          _c(
                            "div",
                            {
                              staticClass:
                                "flex flex-col containerWidth borderLeft bg-white p-3",
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "flex flex-wrap justify-between items-center titleHeight sm:mr-4",
                                },
                                [
                                  _c(
                                    "p",
                                    {
                                      staticClass:
                                        "text-primary-black text-lg font-semibold mainHead ml-3",
                                    },
                                    [_vm._v(" Inbox ")]
                                  ),
                                  !_vm.isContractor
                                    ? _c("NewConversationButtonWithModal", {
                                        staticClass:
                                          "md:m-0 pt-4 pb-5 sm:pt-4 sm:pb-4 sm:p-4 pl-4 sm:pl-6 md:pl-8 mr-3",
                                        attrs: {
                                          size: "lg",
                                          companyId: _vm.company.id,
                                          currentUserId: _vm.currentUser.id,
                                          currentUserRole: _vm.currentUser.role,
                                        },
                                        on: {
                                          createConversation:
                                            _vm.handleCreateConversation,
                                        },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _c(
                                "CustomScroll",
                                { staticClass: "sm:mr-4" },
                                [
                                  _c("InboxConversations", {
                                    attrs: {
                                      conversations: _vm.conversations,
                                      currentUserId: _vm.currentUser.id,
                                      selectedConversationId:
                                        _vm.selectedConversationId,
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("InboxWindow", {
                            staticClass:
                              "w-full sm:p-3 sm:pb-0 sm:pl-5 p-4 pt-0",
                            attrs: {
                              conversation: _vm.conversation,
                              selectedConversationId:
                                _vm.selectedConversationId,
                              currentUserId: _vm.currentUser.id,
                              predefinedMessage: _vm.predefinedMessage,
                              currentUser: _vm.currentUser,
                              uploadingAttachmentId: _vm.uploadingAttachmentId,
                            },
                            on: {
                              conversationDeleted:
                                _vm.handleConversationDeleted,
                              newMessage: _vm.sendMessage,
                            },
                          }),
                        ],
                        1
                      ),
                ]
              ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }